"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var okta_auth_js_1 = require("@okta/okta-auth-js");
var window_location_1 = require("./window-location");
var GafOktaSetup = /** @class */ (function () {
    function GafOktaSetup(windowLocation) {
        this.windowLocation = windowLocation;
        if (this.windowLocation === undefined) {
            this.windowLocation = new window_location_1.WindowLocation();
        }
    }
    GafOktaSetup.prototype.getScopesAndResponseType = function (config, isSingleAudience) {
        if (isSingleAudience === void 0) { isSingleAudience = true; }
        var result = {
            scope: 'openid profile email',
            responseType: 'token id_token',
        };
        if (config !== undefined && config.authorize !== undefined) {
            if (config.authorize.responseType !== undefined) {
                result.responseType = config.authorize.responseType;
            }
            if (isSingleAudience && config.authorize.scopes !== undefined) {
                result.scope = config.authorize.scopes;
            }
        }
        if (isSingleAudience &&
            config !== undefined &&
            config.scopes !== undefined &&
            config.scopes !== null &&
            config.scopes.length > 0) {
            result.scope = result.scope + " " + config.scopes.join(' ');
        }
        return result;
    };
    GafOktaSetup.prototype.createWebAuth = function (config, isSingleAudience) {
        if (isSingleAudience === void 0) { isSingleAudience = true; }
        if (config === undefined) {
            return undefined;
        }
        var result = this.getScopesAndResponseType(config, isSingleAudience);
        var temp = new okta_auth_js_1.OktaAuth({
            clientId: config.clientId || '',
            issuer: config.issuer || '',
            // audience: config.audience || '',
            redirectUri: config.redirectUri || '',
            pkce: config.pkce || false,
            tokenManager: {
                storage: config.tokenManager.storage || '',
                secure: config.tokenManager.secure || false,
                autoRenew: config.tokenManager.autoRenew || false,
            },
            postLogoutRedirectUri: config.postLogoutRedirectUri || '',
            responseType: config.responseType || '',
        });
        return temp;
    };
    GafOktaSetup.prototype.configureEventListener = function () {
        var _this = this;
        try {
            window.addEventListener('message', function (event) {
                var origin = _this.getOrigin();
                if (event.origin !== origin) {
                    return null;
                }
            }, false);
        }
        catch (err) { }
    };
    GafOktaSetup.prototype.getOrigin = function () {
        var origin = this.windowLocation.origin;
        if (!origin) {
            origin =
                this.windowLocation.protocol +
                    '//' +
                    this.windowLocation.hostname +
                    (this.windowLocation.port ? ':' + this.windowLocation.port : '');
        }
        return origin;
    };
    return GafOktaSetup;
}());
exports.GafOktaSetup = GafOktaSetup;
